import React from "react";
import { IconButton, Modal, Stack, Typography } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import CustomCard from "../../../components/CustomCard/CustomCard";
import { styles } from "./styles";

interface Props {
  open: boolean;
  isLoading: boolean;
  onClose: VoidFunction;
  children: React.ReactNode;
}

export const EditModalView = ({ open, onClose, children }: Props) => {
  return (
    <Modal open={open} onClose={onClose} sx={styles.root}>
      <CustomCard sx={styles.card}>
        <Stack sx={styles.header}>
          <Typography
            color="shadesOfDark.dark"
            sx={{ fontSize: "1.6rem", fontWeight: 700 }}
          >
            Editar informações de programação
          </Typography>

          <IconButton onClick={onClose}>
            <CloseOutlined />
          </IconButton>
        </Stack>

        <Typography
          color="shadesOfDark.medium"
          sx={{ fontSize: "1.2rem", marginTop: "-10px" }}
        >
          Ao aprovar esta programação, você não poderá mais alterá-la.
        </Typography>

        {children}
      </CustomCard>
    </Modal>
  );
};
